module.exports = __webpack_public_path__ + "img/RUST-SERVER-COVER-Recovered.da56bb11.png";